// extracted by mini-css-extract-plugin
module.exports = {"root":"Picker_root__2YAhZ","hasStaticRanges":"Picker_hasStaticRanges__UvYWj"};